import { PayoffRequestStatus, TemporaryInfo } from './generated/graphql';

import { User } from '../types/user';

import { Deal } from './dealGql';

export enum FailPayoffRequestReasonEnum {
  COULD_NOT_REACH_CUSTOMER_FOR_CONFERENCE = "Couldn't reach customer for conference",
  CUSTOMER_NEEDS_TO_CALL = 'Customer needs to call',
  TOO_LITTLE_INFORMATION = 'Too little information',
  INCORRECT_SSN = 'Incorrect SSN',
  INCORRECT_DOB = 'Incorrect DOB',
  INCORRECT_VIN = 'Incorrect VIN',
  LIENHOLDER_REFUSED_TO_PROVIDE = 'Lienholder refused to provide',
  OTHER = 'Other',
}

export class FailReason {
  reason: FailPayoffRequestReasonEnum;
  comment: string;

  constructor(reason: FailPayoffRequestReasonEnum, comment = '') {
    this.reason = reason;
    this.comment = comment;
  }
}

export const activePayoffRequestStatuses = [
  PayoffRequestStatus.Pending,
  PayoffRequestStatus.Fetching,
  PayoffRequestStatus.FailureRequested,
];

export class PayoffRequest {
  id?: number;
  deal_id?: number;
  deal: Deal;
  temporary_info_id?: number;
  temporary_info?: TemporaryInfo;
  status?: PayoffRequestStatus;
  vehicle_payoff?: number;
  sales_tax?: number;
  completed_date?: Date;
  good_through_date?: Date;
  created_at?: Date;
  updated_at?: Date;
  fail_reason?: FailReason;
  payoff_clerk_id?: string;
  payoff_clerk?: User;
  needs_payoff_documents?: boolean;
  payoff_documents_uploaded?: boolean;
  requestor?: User;
  is_payoff_intelligence = false;

  constructor() {
    this.deal = new Deal();
  }
}

export const DEFAULT_PAYOFF_CHANGE_MESSAGE =
  'If the Vehicle Payoff has changed, please verify the Taxes.';
